import React from 'react';
import { Building, Plus } from 'lucide-react';

const EtablissementEmptyState = ({ onAddClick }) => {
  return (
    <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-12 text-center">
      <div className="max-w-md mx-auto">
        <div className="bg-gradient-to-br from-[#202654]/10 to-[#2a2f6a]/10 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
          <Building className="h-12 w-12 text-[#202654]" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Aucune information d'établissement
        </h2>
        
        <p className="text-gray-600 text-lg mb-8 leading-relaxed">
          Vous n'avez pas encore configuré les informations de votre établissement. 
          Pour commencer à utiliser la plateforme, veuillez ajouter ces détails essentiels.
        </p>
        
        <button
          onClick={onAddClick}
          className="bg-gradient-to-r from-[#202654] to-[#2a2f6a] hover:from-[#2a2f6a] hover:to-[#202654] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-200 flex items-center justify-center mx-auto shadow-lg hover:shadow-xl transform hover:-translate-y-1"
        >
          <Plus className="h-6 w-6 mr-3" />
          Configurer maintenant
        </button>
        
        <div className="mt-8 p-4 bg-[#202654]/5 rounded-lg border border-[#202654]/20">
          <h3 className="font-semibold text-[#202654] mb-2">Informations requises :</h3>
          <ul className="text-sm text-[#202654]/80 space-y-1 text-left">
            <li>• Nom et devise de l'établissement</li>
            <li>• Coordonnées (contact, email, adresse)</li>
            <li>• Ministère de tutelle</li>
            <li>• Paramètres académiques</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EtablissementEmptyState; 